import * as React from 'react';
import styled from '../../config/theme';

type Props = {
  closeMenu?: VoidFunction;
  children: Array<JSX.Element | false | null | undefined> | JSX.Element | false | null | undefined;
  maxHeight?: number;
  className?: string;
  visibleOverflow?: boolean;
};

const ContextMenuContainer = ({ children, closeMenu, maxHeight, className, visibleOverflow }: Props) => {
  const preventScrollBubbling = (e: React.UIEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
  };

  return (
    <ContextMenuContainerWrapper
      maxHeight={maxHeight || 450}
      onScroll={preventScrollBubbling}
      className={className}
      visibleOverflow={visibleOverflow}
    >
      {children &&
        React.Children.map(
          Array.isArray(children) ? (children.filter((child) => child) as JSX.Element[]) : children,
          (child: JSX.Element, index: number) => React.cloneElement(child, { closeMenu, key: `menu_${index}` })
        )}
    </ContextMenuContainerWrapper>
  );
};

const ContextMenuContainerWrapper = styled.div<{ maxHeight?: number; visibleOverflow?: boolean }>`
  background-color: ${(props) => props.theme.contextMenu.background};
  box-shadow: ${(props) => props.theme.contextMenu.boxShadow};
  display: flex;
  flex-direction: column;
  border-radius: ${(props) => props.theme.contextMenu.borderRadius};
  ${(props) => props.maxHeight && `max-height: ${props.maxHeight}px`};
  overflow-y: ${(props) => (props.visibleOverflow ? 'visible' : 'auto')};
`;

export default ContextMenuContainer;
